import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Stats from "./CovidHerdImmunityStats";
import Simulation from "./CovidHerdImmunitySimulation";
import Chart from "./CovidHerdImmunityChart";
import Inputs from "./CovidHerdImmunityInputs";

const Container = styled.div`
  margin: 30px 0 45px;

  h2 {
    font-size: 2.5rem;
    font-weight: 500;
    margin: 20px 0 15px;
    text-transform: uppercase;

    @media (max-width: 767px) {
      font-size: 2.1rem;
      white-space: nowrap;
    }
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto 20px;

  @media (max-width: 767px) {
    display: block;
  }
`;

function CovidHerdImmunityController({
  start,
  enableInputs,
  prob,
  quarantine,
  immunePopulation,
  confinedPopulation,
}) {
  const [lastSeries, setLastSeries] = useState(null);
  const [simulationParams, setSimulationParams] = useState({
    prob,
    quarantine,
    immunePopulation,
    confinedPopulation,
  });
  const [restart, setRestart] = useState(0);

  const handleUpdateSimulation = (data) => {
    setSimulationParams(data);
    setRestart(restart + 1);
  };

  return (
    <Container>
      <Flex>
        <Stats stats={lastSeries || {}} />
        <Chart lastSeries={lastSeries} restart={restart} />
      </Flex>
      <Simulation
        start={start}
        restart={restart}
        setLastSeries={setLastSeries}
        {...simulationParams}
      />
      {enableInputs && <Inputs updateSimulation={handleUpdateSimulation} />}
    </Container>
  );
}

CovidHerdImmunityController.propTypes = {
  start: PropTypes.bool.isRequired,
  enableInputs: PropTypes.bool,
  prob: PropTypes.number,
  quarantine: PropTypes.number,
  immunePopulation: PropTypes.number,
  confinedPopulation: PropTypes.number,
};

CovidHerdImmunityController.defaultProps = {
  start: false,
};

export default CovidHerdImmunityController;
